export default __webpack_public_path__ + "static/media/product.67f81b02.jpg";